import { RouterType } from '@online-webinar/router';
import { CreateAndEditLiveWebinar } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/create'].update({
        staticData: { title: { page: 'Webinar.Schedule.PageHeading' } },
        component: authGuard(CreateAndEditLiveWebinar, { canBroadcast: true })
    });
};
